module.exports = __webpack_public_path__ + "./assets/img_osakaShinsaibashi_color__5f666a67c6de83fce4d2d09ba80c7283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_osakaShinsaibashi_color.jpg
// module id = 630
// module chunks = 12